module.exports = __webpack_public_path__ + "img/blog-details-4.da57cd9d.jpg";